<script>
import baseMixin from '@/mixins/baseMixin'
import { BookingStatus } from '@/shared/constants/booking/BookingStatus'

export default {
  name: 'TimesheetCandidateDisputeStatusAlert',
  mixins: [baseMixin],
  props: {
    timesheet: {
      required: true,
      type: Object,
    },
  },
  computed: {
    displayModifiedByCandidateAlert() {
      return (
        this.timesheet?.bookingStatus ===
        BookingStatus.CANDIDATE_SUBMITTED_TIMESHEET_MODIFIED
      )
    },
    displayCandidateStatedDidNotHappen() {
      return (
        this.timesheet?.bookingStatus ===
        BookingStatus.CANDIDATE_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN
      )
    },
    compModifiedByCandidateAlertText() {
      return this.$t('timesheets.dispute.candidateModifiedAlertText', [
        this.timesheet?.candidateFullName,
      ])
    },
    compDidNotHappenAlertText() {
      return this.$t(
        'timesheets.dispute.candidateBookingDidNotHappenAlertText',
        [this.timesheet?.candidateFullName]
      )
    },
  },
}
</script>

<template>
  <div>
    <v-alert
      v-if="displayModifiedByCandidateAlert"
      text
      type="info"
      data-testid="timesheet-candidate-dispute-modified-alert"
    >
      {{ compModifiedByCandidateAlertText }}
    </v-alert>
    <v-alert
      v-if="displayCandidateStatedDidNotHappen"
      text
      type="error"
      data-testid="timesheet-candidate-dispute-did-not-happen-alert"
    >
      {{ compDidNotHappenAlertText }}
    </v-alert>
  </div>
</template>
